exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.account_good[data-v-33c4201c] {\n  color: rgb(27, 185, 27);\n  font-size: 14px;\n  line-height: 120%;\n  margin-top: .25rem;\n}\n", ""]);

// exports
